export const alphabeticRegEx = new RegExp(/^(?=.*[a-zA-Z])[A-Za-z]+$/)
export const numericRegEx = new RegExp(/^(?=.*[0-9])[0-9]+$/)
export const alphabeticOrNumeric = new RegExp(/^[a-zA-Z0-9]+$/)
export const emptyOrAlphabetic = new RegExp(/^[a-zA-Z]*$/)
export const noBlankFieldRegEx = new RegExp(/.*\S.*/)
